import { render } from "./TheTienDoDauTu.vue?vue&type=template&id=6bc590ce"
import script from "./TheTienDoDauTu.vue?vue&type=script&lang=js"
export * from "./TheTienDoDauTu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__